import React, { useState } from 'react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { LikertScale } from 'domain/feature/hub/evaluator/idea/evaluate/IdeaApplicationForm/IdeaEvaluation/LikertScale'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Keyboard } from 'swiper'
import {
  IdeaEvaluationSections,
  IdeaEvaluationHeader,
  IdeaEvaluationWrapper,
  IdeaEvaluationTitle,
  IdeaEvaluationSubtitle,
  IdeaEvaluationGroup,
  IdeaEvaluationGroupBottom,
  IdeaEvaluationGroupRightItem,
  IdeaEvaluationSwiperHeader,
  IdeaEvaluationSwiperTitle,
  PointsDiv,
  PointsWrapper,
  IdeaEvaluationSwiperSectionIndex,
  SectionIndexContainer,
  SwiperDiv,
  StickyHeaderWrapper,
  FixedButtonGroup,
  GeneralScoreTag,
  SaveButtonStyled
} from './style'
import { BaseButton, Input } from 'iebt-zing-storybook'
import { trans } from 'sharedKernel/i18n'
import { showModal } from 'components/popup'
import { postProvider, PostFormat } from 'sharedKernel/api'
import { showToast } from 'components/toast'
import { DashboardEvaluatorProgressBar } from 'domain/feature/hub/dashboard/evaluators/evaluatorProgressBar'
import { useParams } from 'react-router'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import {
  criterionCount,
  criterionIsMet,
  bankersRound,
  currentSection,
  changeSolutionPoints,
  goToSectionTop, calculateScore
} from './behavior'
import { IMenuEvaluators } from 'components/menu/state/content/store/contracts'
import { changeMenuEvaluator, store } from 'store'
import { NoContent } from 'components/NoContent'
import NoContentImg from 'assets/images/defaults/no_challenges.png'
import Tippy from '@tippyjs/react'
import { followCursor } from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/scale.css'
import 'tippy.js/themes/translucent.css'
export interface Evaluation {
  name: string
  rounds: number
  fillPercentage: number
  points: number
  comments: string
  order: number
  status: string
  sections: any[]
}

export interface SwiperWrapperProps {
  evaluation: Evaluation
  setIsNavigationBlocked: Function
  resolverId: string
  stepName?: string
}

export const IdeaEvaluation = ({ setIsNavigationBlocked, evaluation, resolverId, stepName }: SwiperWrapperProps): JSX.Element => {
  const labels = {
    evaluationTitle: stepName || trans('Avaliação'),
    evaluationPoints: trans('Nota Geral'),
    saveButton: trans('Salvar'),
    saveTitle: trans('Salvar Avaliação'),
    sendTitle: trans('Enviar Avaliação'),
    saveMessage: trans('Deseja realmente salvar essa avaliação?'),
    sendMessage: trans('Deseja realmente salvar e enviar essa avaliação?'),
    onSuccessSave: trans('Avaliação salva com sucesso!'),
    onSuccessSend: trans('Avaliação enviada com sucesso!'),
    onInvalidSection: trans('Há campos que devem ser preenchidos'),
    onNoSection: trans('Ao menos uma seção deve ser preenchida'),
    confirm: { text: trans('Sim'), value: 'yes' },
    cancel: { text: trans('Não') },
    noEvaluationForm: trans(
      'Ainda não há um formulário de avaliação disponível para esta solução. Entre em contato com a empresa responsável pelo evento.'
    ),
    criterion: trans('Critérios'),
    alertTitle: trans('O campo "Feedback geral" é obrigatório'),
    alertMessage: trans('Para salvar a avaliação é necessário preencher o campo "Feedback geral"'),
    commentsPlaceHolder: trans('O seu comentário será visualizado apenas pela empresa organizadora do evento!'),
    labelComments: trans('Comentários por seção'),
    feedback: trans('Feedback'),
    labelFeedback: trans('Feedback geral'),
    toastMessage: trans('Atenção: O campo \'{}\' deve ser preenchido.'),
    sendEvaluation: trans('Enviar')
  }
  const [activeSection, setActiveSection] = useState(0)
  const [evaluationProps, setEvaluationProps] = useState(evaluation)
  const changeEvaluation = (newValue: number | null, indexSection: number, indexAnswer: number): void => {
    setIsNavigationBlocked(true)
    const newEvaluation = { ...evaluationProps }
    newEvaluation.sections[indexSection].answers[indexAnswer].value = newValue
    setEvaluationProps(newEvaluation)
  }
  // Utilizado para fazer o reload da ProgressBar, caso o contrário ela não atualiza
  const [reloadProgressBar, setReloadProgressBar] = useState(1)

  const state = store.getState()
  const menuEvaluatorsState: IMenuEvaluators = state.menuEvaluatorsState

  const { mutate: persistEvaluationForm, isLoading: isSavingEvaluation } = postProvider()

  const { challengeId, stepId, ideaId } = useParams()

  const navigate = useNavigate()

  const solutionUrl = `v1/hub/evaluator/challenge/${challengeId}/step/${stepId}/solution/${ideaId}`

  const requestSave: PostFormat = {
    url: `/v1/hub/evaluator/challenge/${challengeId}/step/${stepId}/solution/${ideaId}`,
    data: {
      data: {
        challenge: { id: challengeId },
        resolver: { id: resolverId },
        evaluation: {
          ...evaluationProps,
          stepId: stepId,
          sections: evaluationProps.sections.map((section) => {
            return {
              ...section,
              sectionId: section.sectionId,
              answers: section.answers.map((answer) => {
                return { id: answer.id, questionId: answer.questionId, value: answer.value }
              })
            }
          })
        }
      }
    }
  }

  const postFunction = (request: any, isSending: boolean): void => {
    if (isSavingEvaluation) {
      return
    }
    persistEvaluationForm(request, {
      onSuccess: () => {
        const successMessage = isSending ? labels.onSuccessSend : labels.onSuccessSave
        showToast('success', successMessage)
        navigate(`/hub/evaluator/challenge/${challengeId}/steps/${stepId}/solutions`, {
          state: { setToLaunched: true }
        })
      }
    })
  }

  const saveEvaluation = (launch: boolean): void => {
    if (isSavingEvaluation) {
      return
    }
    const isEvaluationVAlidate: boolean = launch ? validateEvaluation() : true
    if (isEvaluationVAlidate) {
      showModal('double', {
        title: launch ? labels.sendTitle : labels.saveTitle,
        message: launch ? labels.sendMessage : labels.saveMessage,
        buttons: [{ text: labels.confirm.text, value: labels.confirm.value }, { text: labels.cancel.text }],
        action: () => handleSaveEvaluation(launch)
      })
    }
  }

  const validateEvaluation = (): boolean => {
    let isValid = true
    if (evaluationProps.comments === '' || evaluationProps.comments === null) {
      showToast('error', labels.toastMessage.replace('{}', 'Feedback geral'))
      isValid = false
    }

    if (!evaluationProps.sections.every((section) => section.comments !== null && section.comments.trim() !== '')) {
      showToast('error', labels.toastMessage.replace('{}', 'Comentários por seção'))
      isValid = false
    }

    if (!isSpecialCompliance) {
      evaluationProps.sections.forEach(section => {
        section.answers.forEach(answer => {
          if (answer.value === null) {
            showToast('error', labels.toastMessage.replace('{}', answer.question))
            isValid = false
          }
        })
      })
    }
    return isValid
  }

  const handleSaveEvaluation = (isSending: boolean): void => {
    if (isSavingEvaluation) {
      return
    }
    postFunction(requestSave, isSending)
    const menuEvaluator = changeSolutionPoints(
      menuEvaluatorsState,
      challengeId,
      stepId,
      resolverId,
      ideaId,
      evaluationPoints
    )
    store.dispatch(changeMenuEvaluator(menuEvaluator))
  }

  const confirmReload = (value: number): void => {
    if (value === null) {
      setReloadProgressBar(Math.random())
    }
  }

  const total = criterionCount(evaluation)
  const current = criterionIsMet(evaluation)
  const percentage = Math.round((current * 100) / total)

  const progressBar = (percentage: number): JSX.Element => {
    return (
      <DashboardEvaluatorProgressBar
        key={reloadProgressBar}
        progressColor={'var(--primary)'}
        progressValue={percentage}
        backgroundColor={'var(--primary-light)'}
      />
    )
  }

  const currentProgressBar = progressBar(percentage)
  const score = calculateScore(evaluation)
   
  const roundGeneralScore = bankersRound(score.currentValue)
  const roundMaxScore =  bankersRound(score.maxValue)
  const evaluationPoints = roundGeneralScore.toFixed(2)

  const criterionGroup = `${current} de ${total} ${labels.criterion}`

  const isSpecialCompliance = evaluationProps.sections.some(section =>
    section.answers.some(answer => answer.type === 'boolean')
  ) || evaluation.name?.toLowerCase().includes('conformidade especial')

  // Check if at least one answer is selected (for Save button)
  const hasAtLeastOneAnswer = evaluationProps.sections.some(section =>
    section.answers.some(answer => answer.value !== null)
  )

  const hasAllRequiredComments = 
    evaluationProps.comments !== null && 
    evaluationProps.comments !== '' && 
    evaluationProps.sections.every(section => 
      section.comments !== null && section.comments.trim() !== ''
    )

  // Check if all answers are selected (for Send button)
  const hasAllAnswers = evaluationProps.sections.every(section =>
    section.answers.every(answer => answer.value !== null)
  )

  const canSendEvaluation = isSpecialCompliance ? hasAllRequiredComments : hasAllAnswers

  const baseTagContent = (points: string): JSX.Element => {
    return (
      <GeneralScoreTag>
        <PointsDiv pointsFontSize={'21px'}>{points}</PointsDiv>
        <PointsDiv pointsFontSize={'12px'}>/{roundMaxScore}</PointsDiv>
      </GeneralScoreTag>
    )
  }

  const noEvaluationFormElement = (
    <IdeaEvaluationWrapper>
      <IdeaEvaluationHeader>
        <IdeaEvaluationTitle>{labels.evaluationTitle}</IdeaEvaluationTitle>
      </IdeaEvaluationHeader>
      <hr className="m-0" />
      <IdeaEvaluationSections>
        <NoContent text={labels.noEvaluationForm} image={NoContentImg} />
      </IdeaEvaluationSections>
    </IdeaEvaluationWrapper>
  )

  if (evaluation.sections.length === 0) {
    return noEvaluationFormElement
  }
  const handleFeedbackChange = (e): void => {
    const newEvaluation = { ...evaluationProps }
    newEvaluation.comments = e.target.value
    setEvaluationProps(newEvaluation)
    setIsNavigationBlocked(true)
  }

  return (
    <IdeaEvaluationWrapper>
      <IdeaEvaluationHeader>
        <IdeaEvaluationTitle>{labels.evaluationTitle}</IdeaEvaluationTitle>
        {!isSpecialCompliance && (
          <IdeaEvaluationGroup>
            <IdeaEvaluationSubtitle>{`${labels.evaluationPoints}`}</IdeaEvaluationSubtitle>
            <IdeaEvaluationGroupRightItem>
              {baseTagContent(evaluationPoints)}
            </IdeaEvaluationGroupRightItem>
          </IdeaEvaluationGroup>
        )}
        <IdeaEvaluationGroupBottom>
          <IdeaEvaluationGroupRightItem>
            <div className="total-items">{criterionGroup}</div>
          </IdeaEvaluationGroupRightItem>
          {currentProgressBar}
        </IdeaEvaluationGroupBottom>
      </IdeaEvaluationHeader>
      <hr className="m-0" />
      <IdeaEvaluationSections id="IdeaEvaluationSections">
        <StickyHeaderWrapper>
          <SectionIndexContainer>
            <IdeaEvaluationSwiperSectionIndex>
              {currentSection(activeSection, parseInt(evaluationProps.sections.length.toString()) + 1)}
            </IdeaEvaluationSwiperSectionIndex>
          </SectionIndexContainer>
          <SwiperDiv>
            <Swiper
              keyboard={{
                enabled: true
              }}
              onSlideChange={(swiper) => {
                setActiveSection(swiper.activeIndex)
                goToSectionTop('IdeaEvaluationSections')
              }}
              slidesPerView={1}
              modules={[Navigation, Keyboard]}
              navigation={true}
              allowSlideNext={true}
              mousewheel={false}
              grabCursor={false}
            >
              {evaluationProps.sections.map((section, sectionIndex) => {
                return (
                  <SwiperSlide key={`swiperSlide.${sectionIndex}`}>
                    <IdeaEvaluationSwiperHeader>
                      <Tippy
                        content={section.name}
                        followCursor={true}
                        plugins={[followCursor]}
                        animation="scale"
                        arrow={false}
                        theme="primary"
                      >
                        <IdeaEvaluationSwiperTitle>{section.name}</IdeaEvaluationSwiperTitle>
                      </Tippy>
                    </IdeaEvaluationSwiperHeader>
                  </SwiperSlide>
                )
              })}
              <SwiperSlide key={`swiperSlide.${evaluationProps.sections.length}`}>
                <IdeaEvaluationSwiperHeader>
                  <IdeaEvaluationSwiperTitle>{labels.feedback}</IdeaEvaluationSwiperTitle>
                </IdeaEvaluationSwiperHeader>
              </SwiperSlide>
            </Swiper>
          </SwiperDiv>
        </StickyHeaderWrapper>
        {evaluationProps.sections[activeSection]?.answers.map((answer, answerIndex) => {
          const updateAnswer = (newValue: number | null): void => {
            confirmReload(answer.value)
            changeEvaluation(newValue, activeSection, answerIndex)
            confirmReload(answer.value)
          }

          return (
            <LikertScale
              key={`likertScale.${activeSection}.${answerIndex}`}
              onChange={updateAnswer}
              onClick={updateAnswer}
              range={answer.type === 'boolean' ? 1 : 5}
              answer={answer.value}
              order={answerIndex}
              question={answer.question}
              description={answer.description}
              gradeInfo={answer.gradeInfo}
            />
          )
        })}
        <div className="pt-4">
          {activeSection < evaluationProps.sections.length
            ? (
              <>
                {evaluationProps.sections.map((section, sectionIndex) => {
                  const handleCommentsChange = (e: any): void => {
                    const newEvaluation = { ...evaluationProps }
                    newEvaluation.sections[activeSection].comments = e.target.value
                    setEvaluationProps(newEvaluation)
                    setIsNavigationBlocked(true)
                  }
                  if (sectionIndex === activeSection) {
                    return (
                      <Input
                        notValidFieldMessage="Esse campo deve ser preenchido"
                        key={`sectionComments.${sectionIndex}`}
                        code="textarea"
                        label={labels.labelComments}
                        isRequired={true}
                        name="comments"
                        onChange={handleCommentsChange}
                        value={section.comments ?? ''}
                        placeholder={labels.commentsPlaceHolder}
                        maxLength={1024}
                      ></Input>
                    )
                  }
                  return <div key={`sectionComments.${sectionIndex}`}></div>
                })}
              </>
              )
            : (
              <>
                <Input
                  notValidFieldMessage="Esse campo deve ser preenchido"
                  key={`sectionComments.${evaluationProps.sections.length}`}
                  code="textarea"
                  label={labels.labelFeedback}
                  name="comments"
                  onChange={handleFeedbackChange}
                  value={evaluationProps.comments ?? ''}
                  isRequired={true}
                  placeholder={labels.commentsPlaceHolder}
                  maxLength={1024}
                ></Input>
              </>
              )}
        </div>
      </IdeaEvaluationSections>
      <FixedButtonGroup>
        <SaveButtonStyled>
          <BaseButton
            btnContent={labels.saveButton}
            size="medium"
            onClick={() => {
              saveEvaluation(false)
            }}
            variant="primary"
            disabled={!hasAtLeastOneAnswer || isSavingEvaluation}
          />
        </SaveButtonStyled>
        <BaseButton
          btnContent={labels.sendEvaluation}
          size="medium"
          onClick={() => {
            saveEvaluation(true)
          }}
          variant="primary"
          disabled={!canSendEvaluation || isSavingEvaluation}
        />
      </FixedButtonGroup>
    </IdeaEvaluationWrapper>
  )
}
